import { Component } from 'san';

import chatService from 'src/services/chat.service';
import {
    IChatReplyCallback,
    IChatReplyCommand,
    IShowChatReplyParams
} from 'src/models';

export default class ReplyChat extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;    // 显示
        isBusy: boolean;
        workflowLogId: number;    // 审批历史项ID
        chatId: string;    // 沟通ID
        message: string;
        callback?: IChatReplyCallback;
    } {
        return {
            isShow: false,
            isBusy: false,
            workflowLogId: null,
            chatId: null,
            message: '',
            callback: null,
        };
    }

    inited() {
    }

    // 显示沟通（外部调用）
    show(params: IShowChatReplyParams) {
        this.data.set('isShow', true);
        this.data.set('isBusy', false);
        this.data.set('workflowLogId', params.workflowLogId);
        this.data.set('chatId', params.chatId);
        this.data.set('callback', params.callback);
    }

    submit() {
        if (this.data.get('isBusy')) {
            return;
        }
        const data = this.data.get();
        const chatReplyCommand: IChatReplyCommand = {
            workflow_log_id: data.workflowLogId,
            chat_id: data.chatId,
            message: data.message
        };
        this.data.set('isBusy', true);
        chatService.replyChat(chatReplyCommand).then(() => {
            if (data.callback) {
                data.callback();
            }
            this.cancel();
            this.data.set('isBusy', false);
        }, () => {
            this.data.set('isBusy', false);
        });
    }

    cancel() {
        this.data.set('isShow', false);
    }
}